import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { environment } from '../environments/environment';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';


import { PagesModule } from './admin/pages.module';
import { MdbCarouselModule } from 'mdb-angular-ui-kit/carousel';
import { FakeBackendInterceptor } from './admin/core/helpers/fake-backend';
import { LayoutsModule } from './admin/layouts/layouts.module';
import { JwtInterceptor } from './admin/core/helpers/jwt.interceptor';
import { ErrorInterceptor } from './admin/core/helpers/error.interceptor';
import { OperationService } from './shared/service/operation/operation.service';
import { SuiviModule } from './admin/pages/suivi/suivi.module';
import { PaginatorModule } from 'primeng/paginator';
import { GoogleMapsModule } from '@angular/google-maps'
import { SkeletonModule } from 'primeng/skeleton';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { TabViewModule } from 'primeng/tabview';
import { MdbTabsModule } from 'mdb-angular-ui-kit/tabs';
import { MarkerDataService } from './shared/service/makerservice/markerDataService';
import { ToastModule } from 'primeng/toast';
import { SharedModule } from './shared/shared.module';
import { FormatMoneyPipe } from './shared/pipe/format-money/format-money.pipe';
import { MenuService } from './shared/service/fetchservice/fetchservice';
import { RouterModule } from '@angular/router';
import { LimitToPipe } from './shared/pipe/limit-to/limit-to.pipe';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AuthInterceptor } from './shared/service/intercepteur/intercepteur';
import { ProfilComponent } from './admin/account/auth/profil/profil/profil.component';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { Dialog, DialogModule } from 'primeng/dialog';
import { PublicDashboardComponent } from './public/public-dashboard/public-dashboard.component';
import { PublicFooterComponent } from './public/public-footer/public-footer.component';
import { PublicHeaderComponent } from './public/public-header/public-header.component';
import { ContactComponent } from './public/page/contact/contact.component';
import { AproposComponent } from './public/page/presentation/apropos/apropos.component';
import { MissionComponent } from './public/page/presentation/mission/mission.component';
import { MetierComponent } from './public/page/presentation/metier/metier.component';
import { RealisationComponent } from './public/page/presentation/realisation/realisation.component';
import { ArticleComponent } from './public/page/presentation/article/article.component';
import { PublicLayoutComponent } from './public/public-layout/public-layout.component';
import { DetailsProjectComponent } from './public/page/details-project/details-project.component';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    PublicDashboardComponent,
    PublicFooterComponent,
    PublicHeaderComponent,
    ContactComponent,
    AproposComponent,
    MissionComponent,
    MetierComponent,
    RealisationComponent,
    ArticleComponent,
    PublicLayoutComponent,
    DetailsProjectComponent
  ],
  imports: [
    BrowserModule, 
    BrowserAnimationsModule, 
    HttpClientModule,
    AppRoutingModule,
    PagesModule,
    LayoutsModule,
    FormsModule,
    MdbCarouselModule,
    GoogleMapsModule,
    LeafletModule,
    SkeletonModule,
    PaginatorModule ,
    TabViewModule,
    MdbTabsModule,
    ToastModule,
    RouterModule,
    NgxUiLoaderModule,
    ConfirmDialogModule,
    DropdownModule,
    ConfirmPopupModule,
    DialogModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader, 
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }), 
    SuiviModule,
    SharedModule,

    
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: FakeBackendInterceptor, multi: true },
    OperationService,
    MarkerDataService,
    // FormatMoneyPipe,
    // LimitToPipe,
    MenuService

  ],
  bootstrap: [AppComponent]
})
export class AppModule { } 
